/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Actions from './Actions/index'
import CloseAction from './CloseAction/index'
import InputTextAreaFixed from 'DesignSystem/InputTextAreaFixed/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Notes/Content/NewOrEdit/Content",
  onChange,
  onSubmit
  
}) {
let selectedNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'selected_note',
path: 'note',
})
let selectedNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'selected_note',
path: 'note',
})
let selectedNoteNoteSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected_note',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let selectedNoteAlertValueData = fromData.useDataValue({ viewPath,
context: 'selected_note',
path: 'alert',
})
let selectedNoteAlertChangeData = fromData.useDataChange({ viewPath,
context: 'selected_note',
path: 'alert',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h2"
 text="Note"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<InputTextAreaFixed
  viewPath={`${viewPath}/InputTextAreaFixed`}
 marginTop={dtSpaceS}
 autoFocus={false}
 data="selected_note.note"
 onChange={selectedNoteNoteChangeData}
 onSubmit={selectedNoteNoteSubmitData}
 placeholder="Waiting for your input..."
 type="text"
 value={selectedNoteNoteValueData}
 width="50%"
/>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 data="selected_note.alert"
 value={selectedNoteAlertValueData}
 onChange={selectedNoteAlertChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Get alerts"
/>
</React.Fragment>
)}
</TysiaToggle>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}